document.addEventListener('DOMContentLoaded', function() {

    // VARIANT OPTIONS SIZE UPDATE
    var normaliseSizeKey = function(value) {
        if (!value) {
            return '';
        }
        return value
            .toString()
            .replace(/[\u00A0]/g, ' ')
            .replace(/[^0-9a-zA-Z.\-]/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .toUpperCase();
    };

    var buildSizeGuideMap = function() {
        var guideSource = document.getElementById('metafield-guide');
        if (!guideSource) {
            return null;
        }

        var tableBodies = guideSource.querySelectorAll('tbody');
        if (!tableBodies || !tableBodies.length) {
            return null;
        }

        var map = {};
        var mmBody = tableBodies[0];
        var rows = mmBody.querySelectorAll('tr');

        for (var i = 1; i < rows.length; i += 1) {
            var cells = rows[i].children;
            if (!cells || cells.length < 5) {
                continue;
            }

            var point = cells[0].textContent ? cells[0].textContent.trim() : '';
            var uk = cells[2].textContent ? cells[2].textContent.trim() : '';
            var us = cells[3].textContent ? cells[3].textContent.trim() : '';
            var eu = cells[4].textContent ? cells[4].textContent.trim() : '';

            if (!point && !uk && !us && !eu) {
                continue;
            }

            var entry = {
                point: point,
                UK: uk,
                US: us,
                EU: eu
            };

            var registerKey = function(value) {
                var key = normaliseSizeKey(value);
                if (key) {
                    map[key] = entry;
                }
            };

            registerKey(point);
            registerKey(uk);
            registerKey(us);
            registerKey(eu);
            registerKey('UK ' + uk);
            registerKey('US ' + us);
            registerKey('EU ' + eu);
            registerKey('UK' + uk);
            registerKey('US' + us);
            registerKey('EU' + eu);
        }

        return map;
    };

  // VARIANT OPTIONS SIZE UPDATE - Using conversion offsets
  var sizeRegionContainer = document.querySelector('.twa-size-region-selector');
  var sizeWrapper = document.querySelector('.custom-size-wrapper');

  if (sizeRegionContainer && sizeWrapper) {
    var regionButtons = Array.prototype.slice.call(
      sizeRegionContainer.querySelectorAll('.twa-size-region-btn')
    );
    
    if (regionButtons.length) {
      // Default conversion offsets
      var SIZE_CONVERSION_DEFAULTS = {
        eu: 34,
        us: 1
      };

      var sizeLabels = [];
      var currentRegion = 'UK';

      var findActiveRegionButton = function() {
        for (var j = 0; j < regionButtons.length; j += 1) {
          if (regionButtons[j].classList.contains('twa-size-active')) {
            return regionButtons[j];
          }
        }
        return null;
      };

      var formatSizeValue = function(value) {
        if (value === null || value === undefined || value === '') return '';
        var numeric = Number(value);
        if (isNaN(numeric)) return String(value);
        return Number.isInteger(numeric) ? String(numeric) : numeric.toFixed(1).replace(/\.0$/, '');
      };

      var extractUkSize = function(input, label) {
        // Try to get from data-value first
        if (input.dataset && input.dataset.value) {
          var dataValue = input.dataset.value.trim();
          if (dataValue) return dataValue;
        }

        // Try to extract from value attribute
        var value = input.value || '';
        var ukMatch = value.match(/UK[\s:-]*([0-9]+(?:\.[0-9])?)/i);
        if (ukMatch) return ukMatch[1];

        // Try to extract numeric value from label text
        var labelText = label.textContent || '';
        var numericMatch = labelText.match(/([0-9]+(?:\.[0-9])?)/);
        if (numericMatch) return numericMatch[1];

        return '';
      };

      var buildSizeLabels = function(ukSize, defaultText) {
        var values = { uk: '', eu: '', us: '' };

        if (!ukSize) {
          return {
            values: values,
            defaultLabel: defaultText
          };
        }

        var numericUk = Number(ukSize);
        var hasNumericUk = !isNaN(numericUk);

        var formattedUk = formatSizeValue(ukSize);
        values.uk = formattedUk;

        if (hasNumericUk) {
          var euValue = formatSizeValue(numericUk + SIZE_CONVERSION_DEFAULTS.eu);
          var usValue = formatSizeValue(numericUk + SIZE_CONVERSION_DEFAULTS.us);
          values.eu = euValue;
          values.us = usValue;
        } else {
          // Fallback to UK value if not numeric
          values.eu = formattedUk;
          values.us = formattedUk;
        }

        return {
          values: values,
          defaultLabel: formattedUk || defaultText
        };
      };

      var prepareSizeLabels = function() {
        sizeLabels = [];
        var items = sizeWrapper.querySelectorAll('.custom-size-item');
        
        for (var i = 0; i < items.length; i += 1) {
          var item = items[i];
          var input = item.querySelector('input[type="radio"]');
          var label = item.querySelector('label');

          if (!input || !label) {
            continue;
          }

          // Store the original label text only once
          if (!label.dataset.originalText) {
            label.dataset.originalText = label.textContent ? label.textContent.trim() : '';
          }

          // Extract UK size from the variant
          var ukSize = extractUkSize(input, label);
          
          // Build size labels using conversion offsets
          var sizeData = buildSizeLabels(ukSize, label.dataset.originalText);
          
          // Store the calculated sizes in dataset (only if not already set)
          if (!label.dataset.ukSize) {
            label.dataset.ukSize = sizeData.values.uk || sizeData.defaultLabel;
          }
          if (!label.dataset.usSize) {
            label.dataset.usSize = sizeData.values.us || sizeData.defaultLabel;
          }
          if (!label.dataset.euSize) {
            label.dataset.euSize = sizeData.values.eu || sizeData.defaultLabel;
          }

          sizeLabels.push(label);
        }
      };

      var updateLabelDisplay = function(region) {
        var datasetKey = region.toLowerCase() + 'Size';
        
        for (var i = 0; i < sizeLabels.length; i += 1) {
          var label = sizeLabels[i];
          var replacement = label.dataset[datasetKey];
          
          if (!replacement || replacement === '') {
            replacement = label.dataset.ukSize || label.dataset.originalText || label.textContent;
          }
          
          if (replacement) {
            label.textContent = replacement;
          }
        }
      };

      // Initialize with the active region
      var activeButton = findActiveRegionButton();
      if (activeButton && activeButton.textContent) {
        currentRegion = activeButton.textContent.replace(/[\s\u00A0]+/g, '').toUpperCase() || 'UK';
      }

      prepareSizeLabels();
      updateLabelDisplay(currentRegion);

      // Add click event listeners to region buttons
      for (var b = 0; b < regionButtons.length; b += 1) {
        (function(button) {
          button.addEventListener('click', function() {
            if (button.classList.contains('twa-size-active')) {
              return;
            }

            // Remove active class from all buttons
            for (var r = 0; r < regionButtons.length; r += 1) {
              regionButtons[r].classList.remove('twa-size-active');
            }

            // Add active class to clicked button
            button.classList.add('twa-size-active');
            currentRegion = button.textContent.replace(/[\s\u00A0]+/g, '').toUpperCase() || 'UK';
            updateLabelDisplay(currentRegion);
          });
        })(regionButtons[b]);
      }

      // Watch for changes in the size wrapper (for product switches)
      if (window.MutationObserver) {
        var observer = new MutationObserver(function(mutations) {
          var shouldRefresh = false;
          
          for (var idx = 0; idx < mutations.length; idx += 1) {
            if (mutations[idx].type === 'childList') {
              shouldRefresh = true;
              break;
            }
          }
          
          if (shouldRefresh) {
            prepareSizeLabels();
            updateLabelDisplay(currentRegion);
          }
        });
        
        observer.observe(sizeWrapper, { childList: true });
      }
    }
  }
    // END VARIANT OPTIONS SIZE UPDATE

    // COUNTDOWN FOR DISPATCH TIME
    var dispatchTimeElements = document.querySelectorAll('.twa-dispatchtime');

    if (dispatchTimeElements.length > 0) {
        var dispatchEls = Array.prototype.slice.call(dispatchTimeElements);

        // Check if dispatch info should be visible based on date range
        var isWithinDispatchRange = function(element) {
            var parent = element.closest('.twa-usp-header');
            if (!parent) return true;

            var startTimestamp = parent.getAttribute('data-dispatch-start');
            var endTimestamp = parent.getAttribute('data-dispatch-end');

            if (!startTimestamp || !endTimestamp) return true;

            var now = Date.now();
            var start = parseInt(startTimestamp, 10) * 1000;
            var end = parseInt(endTimestamp, 10) * 1000;

            return now >= start && now <= end;
        };


        var isWithinRecurringRange = function(element) {
            var parent = element.closest('.twa-usp-header');
            if (!parent) return true;

            var startRecurring = parent.getAttribute('data-start-recurring');
            var endRecurring = parent.getAttribute('data-end-recurring');

            if (!startRecurring || !endRecurring) return true;

            // Parse day name to index (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
            var dayNameToIndex = {
                'sunday': 0, 'monday': 1, 'tuesday': 2, 'wednesday': 3,
                'thursday': 4, 'friday': 5, 'saturday': 6
            };

            // Parse recurring format: "Monday 00:01:00 GMT+0100"
            var parseRecurring = function(str) {
                var parts = str.trim().split(' ');
                if (parts.length < 2) return null;

                var dayName = parts[0].toLowerCase();
                var timePart = parts[1];
                var tzPart = parts.length > 2 ? parts[2] : 'GMT+0000';

                var dayIndex = dayNameToIndex[dayName];
                if (dayIndex === undefined) return null;

                var timeParts = timePart.split(':');
                var hour = parseInt(timeParts[0], 10) || 0;
                var minute = parseInt(timeParts[1], 10) || 0;
                var second = parseInt(timeParts[2], 10) || 0;

                // Parse timezone offset (e.g., GMT+0100 -> +60 minutes)
                var tzOffsetMinutes = 0;
                var tzMatch = tzPart.match(/GMT([+-])(\d{2})(\d{2})/i);
                if (tzMatch) {
                    var sign = tzMatch[1] === '+' ? 1 : -1;
                    var tzHours = parseInt(tzMatch[2], 10);
                    var tzMins = parseInt(tzMatch[3], 10);
                    tzOffsetMinutes = sign * (tzHours * 60 + tzMins);
                }

                return { day: dayIndex, hour: hour, minute: minute, second: second, tzOffsetMinutes: tzOffsetMinutes };
            };

            var startConfig = parseRecurring(startRecurring);
            var endConfig = parseRecurring(endRecurring);

            if (!startConfig || !endConfig) return true;

            // Convert a day/time in specified timezone to UTC week minutes
            var toUtcWeekMinutes = function(day, hour, minute, second, tzOffsetMinutes) {
                // Total minutes from Sunday 00:00 in the specified timezone
                var localWeekMinutes = (day * 24 * 60) + (hour * 60) + minute + (second / 60);
                // Convert to UTC by subtracting timezone offset
                var utcWeekMinutes = localWeekMinutes - tzOffsetMinutes;
                // Handle week wrap-around (normalize to 0-10079 range, i.e., 7 days * 24 hours * 60 minutes)
                var weekTotalMinutes = 7 * 24 * 60;
                utcWeekMinutes = ((utcWeekMinutes % weekTotalMinutes) + weekTotalMinutes) % weekTotalMinutes;
                return utcWeekMinutes;
            };

            // Get current UTC time as week minutes
            var now = new Date();
            var utcDay = now.getUTCDay();
            var utcHour = now.getUTCHours();
            var utcMinute = now.getUTCMinutes();
            var utcSecond = now.getUTCSeconds();
            var currentUtcWeekMinutes = (utcDay * 24 * 60) + (utcHour * 60) + utcMinute + (utcSecond / 60);

            // Convert start and end times to UTC week minutes
            var startUtcWeekMinutes = toUtcWeekMinutes(
                startConfig.day, startConfig.hour, startConfig.minute, startConfig.second, startConfig.tzOffsetMinutes
            );
            var endUtcWeekMinutes = toUtcWeekMinutes(
                endConfig.day, endConfig.hour, endConfig.minute, endConfig.second, endConfig.tzOffsetMinutes
            );

            // Handle range within same week (e.g., Monday to Friday in UTC)
            if (startUtcWeekMinutes <= endUtcWeekMinutes) {
                return currentUtcWeekMinutes >= startUtcWeekMinutes && currentUtcWeekMinutes <= endUtcWeekMinutes;
            }

            // Handle range that wraps around week (e.g., Friday to Monday in UTC)
            return currentUtcWeekMinutes >= startUtcWeekMinutes || currentUtcWeekMinutes <= endUtcWeekMinutes;
        };

        // Check if a date is in British Summer Time (BST)
        var isInBST = function(date) {
            var year = date.getUTCFullYear();
            
            // BST starts: last Sunday of March at 01:00 UTC
            var marchLast = new Date(Date.UTC(year, 2, 31, 1, 0, 0));
            while (marchLast.getUTCDay() !== 0) {
                marchLast.setUTCDate(marchLast.getUTCDate() - 1);
            }
            
            // BST ends: last Sunday of October at 01:00 UTC
            var octoberLast = new Date(Date.UTC(year, 9, 31, 1, 0, 0));
            while (octoberLast.getUTCDay() !== 0) {
                octoberLast.setUTCDate(octoberLast.getUTCDate() - 1);
            }
            
            return date.getTime() >= marchLast.getTime() && date.getTime() < octoberLast.getTime();
        };

        // Get UK timezone offset in minutes (0 for GMT, 60 for BST)
        var getUKOffset = function(date) {
            return isInBST(date) ? 60 : 0;
        };

        // Convert UTC date to UK time
        var toUKTime = function(date) {
            var ukOffset = getUKOffset(date);
            return new Date(date.getTime() + (ukOffset * 60000));
        };

        // Cutoff times are in UK timezone
        var getCutoffConfig = function(dayIndex) {
            if (dayIndex >= 1 && dayIndex <= 4) {
                return { hour: 20, minute: 0 }; // 20:00 UK time (Mon-Thu)
            }
            return { hour: 14, minute: 30 }; // 14:30 UK time (Fri-Sun)
        };

        var computeNextDeadline = function(referenceDate) {
            // Convert reference date to UK time for day/time calculations
            var ukOffset = getUKOffset(referenceDate);
            var ukNow = toUKTime(referenceDate);
            
            var baseYear = ukNow.getUTCFullYear();
            var baseMonth = ukNow.getUTCMonth();
            var baseDate = ukNow.getUTCDate();

            for (var offset = 0; offset < 7; offset += 1) {
                // Create candidate date in UK timezone
                var candidateUK = new Date(Date.UTC(baseYear, baseMonth, baseDate + offset, 0, 0, 0, 0));
                
                // Get cutoff config based on UK day
                var dayConfig = getCutoffConfig(candidateUK.getUTCDay());
                candidateUK.setUTCHours(dayConfig.hour, dayConfig.minute, 0, 0);
                
                // Convert UK time back to UTC for comparison
                // Check BST for the candidate date itself
                var candidateUKOffset = getUKOffset(candidateUK);
                var candidateUTC = new Date(candidateUK.getTime() - (candidateUKOffset * 60000));

                if (offset === 0 && candidateUTC.getTime() <= referenceDate.getTime()) {
                    continue;
                }

                return candidateUTC;
            }

            return null;
        };

        var formatCountdown = function(distance) {
            if (distance <= 0) {
                return '<span class="countdown-container"><span class="countdown-value">00</span><span class="countdown-unit">H</span></span> <span class="countdown-container"><span class="countdown-value">00</span><span class="countdown-unit">M</span></span> <span class="countdown-container"><span class="countdown-value">00</span><span class="countdown-unit">S</span></span>';
            }

            var totalSeconds = Math.floor(distance / 1000);
            var totalHours = Math.floor(totalSeconds / 3600);
            var minutes = Math.floor((totalSeconds % 3600) / 60);
            var seconds = totalSeconds % 60;

            var paddedHours = totalHours < 10 ? '0' + totalHours : String(totalHours).padStart(2, '0');
            var paddedMinutes = minutes < 10 ? '0' + minutes : String(minutes).padStart(2, '0');
            var paddedSeconds = seconds < 10 ? '0' + seconds : String(seconds).padStart(2, '0');

            return '<span class="countdown-container"><span class="countdown-value">' + paddedHours + '</span><span class="countdown-unit">H</span></span> ' +
                   '<span class="countdown-container"><span class="countdown-value">' + paddedMinutes + '</span><span class="countdown-unit">M</span></span> ' +
                   '<span class="countdown-container"><span class="countdown-value">' + paddedSeconds + '</span><span class="countdown-unit">S</span></span>';
        };

        var initialPrefixes = dispatchEls.map(function(element) {
            var prefixAttr = element.getAttribute('data-countdown-prefix');
            var existingText = element.textContent ? element.textContent.trim() : '';
            return prefixAttr !== null ? prefixAttr : existingText;
        });

        var deadline = computeNextDeadline(new Date());

        var renderCountdown = function() {
            var now = new Date();

            if (!deadline || deadline <= now) {
                deadline = computeNextDeadline(now);
                if (!deadline) {
                    dispatchEls.forEach(function(element, index) {
                        var prefix = initialPrefixes[index];
                        element.textContent = prefix || '';
                    });
                    return;
                }
            }

            var remaining = deadline.getTime() - now.getTime();
            var formatted = formatCountdown(remaining);

            dispatchEls.forEach(function(element, index) {
                var prefix = initialPrefixes[index];
                var parent = element.closest('.twa-usp-header');
                var dispatchType = parent.getAttribute('data-dispatchtype');
                // Hide parent if outside dispatch date range
                if (!isWithinDispatchRange(element) && dispatchType == 'schedule') {
                  if (parent) parent.classList.add('hidden');
                  return;
                }
                if (!isWithinRecurringRange(element) && dispatchType == 'recurring') {
                  if (parent) parent.classList.add('hidden');
                  return;
                }

                if (parent) parent.classList.remove('hidden');
                element.innerHTML = prefix ? prefix + ' ' + formatted : formatted;
            });
        };

        renderCountdown();
        setInterval(renderCountdown, 1000);
    }
    // END COUNTDOWN FOR DISPATCH TIME

    // STICKY ADD TO CART
    class StickyAddToCart {
        constructor() {
            this.stickyATC = document.querySelector('sticky-add-to-cart');
            this.stickyBtn = document.querySelector('.twa-satc-btn');
            this.selectedVariantId = null;
            this.scrollThreshold = 300;
            this._observer = null;
            this._destroyed = false;
            this._noInit = false;

            if (!this.stickyATC || !this.stickyBtn) {
                this._noInit = true;
                return;
            }

            this._boundScroll = this.handleScroll.bind(this);
            this._boundDocChange = function (e) {
                if (
                    e.target.matches &&
                    (e.target.matches('variant-radios input[type="radio"]') ||
                        e.target.matches('variant-selects select'))
                ) {
                    this.updateButton();
                }
            }.bind(this);
            this._boundVariantChange = function () {
                this.updateButton();
            }.bind(this);
            this._boundBtnClick = function (e) {
                this.handleButtonClick(e);
            }.bind(this);

            this.init();
        }

        destroy() {
            if (this._noInit || this._destroyed) {
                return;
            }
            this._destroyed = true;
            window.removeEventListener('scroll', this._boundScroll);
            document.removeEventListener('change', this._boundDocChange);
            document.removeEventListener('variant:change', this._boundVariantChange);
            if (this.stickyBtn) {
                this.stickyBtn.removeEventListener('click', this._boundBtnClick);
            }
            if (this._observer) {
                this._observer.disconnect();
                this._observer = null;
            }
        }

        init() {
            this.bindEvents();
            this.updateButton();
            this.handleScroll();
        }

        bindEvents() {
            window.addEventListener('scroll', this._boundScroll);
            this.stickyBtn.addEventListener('click', this._boundBtnClick);
            document.addEventListener('change', this._boundDocChange);
            document.addEventListener('variant:change', this._boundVariantChange);

            var productFormButton = this.getProductFormButton();
            if (productFormButton) {
                this._observer = new MutationObserver(function () {
                    this.updateButton();
                }.bind(this));
                this._observer.observe(productFormButton, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                });
            }
        }

        handleScroll() {
            if (window.scrollY > this.scrollThreshold) {
                this.show();
            } else {
                this.hide();
            }
        }

        show() {
            this.stickyATC.classList.remove('twa-satc-hidden');
        }

        hide() {
            this.stickyATC.classList.add('twa-satc-hidden');
        }

        getProductFormButton() {
            return document.querySelector('product-form button[type="submit"]');
        }

        getProductFormButtonText() {
            const productFormButton = this.getProductFormButton();
            if (productFormButton) {
                const span = productFormButton.querySelector('span');
                if (span) {
                    return span.textContent.trim();
                }
                return productFormButton.textContent.trim();
            }
            return 'ADD TO CART';
        }

        checkSelectedVariant() {
            // Check for selected radio buttons (variant-radios)
            const selectedRadio = document.querySelector('variant-radios input[type="radio"]:checked');
            if (selectedRadio) {
                return selectedRadio.value;
            }

            // Check for selected variant in variant-selects (dropdown)
            const variantSelect = document.querySelector('variant-selects select');
            if (variantSelect && variantSelect.value) {
                return variantSelect.value;
            }

            return null;
        }

        updateButton() {
            this.selectedVariantId = this.checkSelectedVariant();
            
            if (this.selectedVariantId) {
                // Use the same text as the product form button
                const productFormButtonText = this.getProductFormButtonText();
                this.stickyBtn.textContent = productFormButtonText;
                this.stickyBtn.classList.add('has-variant-selected');
            } else {
                this.stickyBtn.textContent = 'SELECT SIZE';
                this.stickyBtn.classList.remove('has-variant-selected');
            }
        }

        scrollToVariantPicker() {
            const variantPicker = document.querySelector('variant-radios') || 
                                document.querySelector('variant-selects') ||
                                document.querySelector('.custom-size-wrapper');
            
            if (variantPicker) {
                variantPicker.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'center' 
                });
            }
        }

        addToCart() {
            const productForm = document.querySelector('product-form form');
            if (productForm) {
                const submitButton = productForm.querySelector('button[type="submit"]');
                if (submitButton) {
                    submitButton.click();
                }
            }
        }

        handleButtonClick(e) {
            e.preventDefault();
            
            if (this.selectedVariantId) {
                // If variant is selected, add to cart
                this.addToCart();
            } else {
                // If no variant selected, scroll to variant picker
                this.scrollToVariantPicker();
            }
        }
    }

    /**
     * Re-bind sticky ATC after PDP section AJAX swap (e.g. clothing colour swatch).
     */
    window.__twaInitStickyAddToCart = function () {
        if (window.__twaStickyAddToCartInstance) {
            window.__twaStickyAddToCartInstance.destroy();
            window.__twaStickyAddToCartInstance = null;
        }
        window.__twaStickyAddToCartInstance = new StickyAddToCart();
    };

    window.__twaInitStickyAddToCart();
    // END STICKY ADD TO CART
});

(function () {
    if (typeof customElements === 'undefined') {
        return;
    }

    /**
     * Product page tab strip: header buttons with data-tab match panel id.
     */
    if (!customElements.get('twa-product-tabs')) {
    class TwaProductTabs extends HTMLElement {
        connectedCallback() {
            if (this._initialized) {
                return;
            }
            this._initialized = true;
            this.init();
        }

        init() {
            var buttons = this.querySelectorAll(
                '.twa-product-tabheader-btn[data-tab]'
            );
            var panels = this.querySelectorAll('.twa-product-tabcontent-item');

            if (!buttons.length || !panels.length) {
                return;
            }

            var header = this.querySelector('.twa-product-tabheader');
            if (header && !header.hasAttribute('role')) {
                header.setAttribute('role', 'tablist');
            }

            var self = this;
            var i;

            for (i = 0; i < buttons.length; i++) {
                buttons[i].addEventListener('click', function (e) {
                    var id = e.currentTarget.getAttribute('data-tab');
                    self.activate(id);
                });
                if (!buttons[i].hasAttribute('role')) {
                    buttons[i].setAttribute('role', 'tab');
                }
            }

            for (i = 0; i < panels.length; i++) {
                if (!panels[i].hasAttribute('role')) {
                    panels[i].setAttribute('role', 'tabpanel');
                }
            }

            var initialId = null;
            for (i = 0; i < buttons.length; i++) {
                if (buttons[i].classList.contains('twa-tabactive')) {
                    initialId = buttons[i].getAttribute('data-tab');
                    break;
                }
            }
            if (!initialId) {
                initialId = buttons[0].getAttribute('data-tab');
            }
            this.activate(initialId);
        }

        activate(tabId) {
            if (!tabId) {
                return;
            }

            var buttons = this.querySelectorAll(
                '.twa-product-tabheader-btn[data-tab]'
            );
            var panels = this.querySelectorAll('.twa-product-tabcontent-item');
            var i;

            for (i = 0; i < buttons.length; i++) {
                var btn = buttons[i];
                var isActive = btn.getAttribute('data-tab') === tabId;
                btn.classList.toggle('twa-tabactive', isActive);
                btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
            }

            for (i = 0; i < panels.length; i++) {
                var panel = panels[i];
                var isActive = panel.id === tabId;
                panel.classList.toggle('twa-tabactivecontents', isActive);
                if (isActive) {
                    panel.removeAttribute('hidden');
                } else {
                    panel.setAttribute('hidden', '');
                }
            }
        }
    }

    customElements.define('twa-product-tabs', TwaProductTabs);
    }

    /**
     * Re-run inline scripts inside a replaced section (jQuery init, etc.).
     * @param {HTMLElement} root
     */
    function reexecuteInlineScripts(root) {
        var scripts = Array.prototype.slice.call(root.querySelectorAll('script'));
        var i;
        for (i = 0; i < scripts.length; i++) {
            var oldScript = scripts[i];
            if (oldScript.src) {
                continue;
            }
            var newScript = document.createElement('script');
            var a;
            for (a = 0; a < oldScript.attributes.length; a++) {
                var attr = oldScript.attributes[a];
                newScript.setAttribute(attr.name, attr.value);
            }
            newScript.textContent = oldScript.textContent;
            oldScript.parentNode.replaceChild(newScript, oldScript);
        }
    }

    /**
     * Ensure mobile product image carousels are initialized after section swaps.
     * @param {HTMLElement} root
     */
    function initMobileProductCarousels(root) {
        if (!root || !window.jQuery) {
            return;
        }

        var $ = window.jQuery;
        if (!$.fn || typeof $.fn.owlCarousel !== 'function') {
            return;
        }

        var selector = '.custom-product-images-carousel.owl-carousel';
        var $carousels = $(root).find(selector);

        if (root.matches && root.matches(selector)) {
            $carousels = $carousels.add(root);
        }

        if (!$carousels.length) {
            return;
        }

        $carousels.each(function () {
            var $carousel = $(this);

            if ($carousel.data('owl.carousel')) {
                $carousel.trigger('destroy.owl.carousel');
            }

            $carousel.owlCarousel({
                loop: false,
                center: true,
                margin: 0,
                nav: false,
                dots: true,
                responsiveClass: true,
                items: 1,
            });
        });
    }

    if (!customElements.get('twa-clothing-swatch')) {
    /**
     * Swaps the main product section when a colour swatch (linked product) is chosen.
     */
    class TwaClothingSwatch extends HTMLElement {
        connectedCallback() {
            if (this._initialized) {
                return;
            }
            this._initialized = true;
            this._onClick = this._onClick.bind(this);
            this.addEventListener('click', this._onClick);
        }

        disconnectedCallback() {
            this.removeEventListener('click', this._onClick);
        }

        _onClick(e) {
            var btn = e.target.closest(
                'button.twa__cs-swatch-switcher[data-url]'
            );
            if (!btn) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            var href = btn.getAttribute('data-url');
            var sectionId = this.dataset.sectionId;
            if (!href || !sectionId) {
                return;
            }

            var targetUrl;
            try {
                targetUrl = new URL(href, window.location.origin);
            } catch (err) {
                return;
            }

            if (targetUrl.origin !== window.location.origin) {
                return;
            }

            // Guard against ghost clicks while swapping section markup.
            window.__twaSuppressSidemodalOpenUntil = Date.now() + 800;
            this._loadProduct(targetUrl, sectionId);
        }

        _loadProduct(targetUrl, sectionId) {
            var sectionEl = document.getElementById(
                'shopify-section-' + sectionId
            );
            if (!sectionEl) {
                return;
            }

            var fetchUrl = new URL(targetUrl.toString());
            fetchUrl.searchParams.set('section_id', sectionId);

            sectionEl.classList.add('twa-clothing-section--loading');
            sectionEl.setAttribute('aria-busy', 'true');

            fetch(fetchUrl.toString(), { credentials: 'same-origin' })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Fetch failed');
                    }
                    return response.text();
                })
                .then(function (html) {
                    var doc = new DOMParser().parseFromString(
                        html,
                        'text/html'
                    );
                    var fresh = doc.getElementById(
                        'shopify-section-' + sectionId
                    );
                    if (!fresh) {
                        throw new Error('Section markup missing');
                    }

                    var imported = document.importNode(fresh, true);
                    sectionEl.replaceWith(imported);

                    reexecuteInlineScripts(imported);
                    initMobileProductCarousels(imported);
                    window.__twaSuppressSidemodalOpenUntil = Date.now() + 800;

                    var clean = new URL(targetUrl.pathname, window.location.origin);
                    if (targetUrl.search) {
                        clean.search = targetUrl.search;
                    }
                    window.history.pushState({}, '', clean.pathname + clean.search);

                    if (typeof window.__twaInitStickyAddToCart === 'function') {
                        window.__twaInitStickyAddToCart();
                    }

                    if (typeof window.initializeLiveViewBadges === 'function') {
                        window.initializeLiveViewBadges();
                    }

                    imported.dispatchEvent(
                        new CustomEvent('shopify:section:load', {
                            bubbles: true,
                            detail: { sectionId: sectionId },
                        })
                    );

                    document.dispatchEvent(
                        new CustomEvent('twa:clothing-swatch:replaced', {
                            bubbles: true,
                            detail: { url: clean.toString() },
                        })
                    );

                    const trustbox = document.getElementById('trustbox');

                    if( trustbox ) {
                        window.Trustpilot.loadFromElement(trustbox);
                    }

                    tfcapi('calculate');
                })
                .catch(function () {
                    window.location.assign(targetUrl.pathname + targetUrl.search);
                })
                .finally(function () {
                    var el = document.getElementById(
                        'shopify-section-' + sectionId
                    );
                    if (el) {
                        el.classList.remove('twa-clothing-section--loading');
                        el.removeAttribute('aria-busy');
                    }
                });
        }
    }

    customElements.define('twa-clothing-swatch', TwaClothingSwatch);
    }
})();

(function () {
    /**
     * Sync .twa__cs-modelinfo when variant (e.g. size) changes — mirrors Liquid
     * selected_or_first_available_variant.title | split: '/' | last.
     */
    function sizeLabelFromVariantTitle(title) {
        if (!title) {
            return '';
        }
        var parts = String(title).split('/');
        return parts[parts.length - 1].trim();
    }

    function findCurrentVariantFromRadios(vr) {
        var variantsScript = vr.querySelector('[data-product-variants]');
        if (!variantsScript) {
            return null;
        }
        var variants;
        try {
            variants = JSON.parse(variantsScript.textContent);
        } catch (e) {
            return null;
        }

        var fieldsets = vr.querySelectorAll('fieldset');
        var selectedOptions = [];
        var i;
        for (i = 0; i < fieldsets.length; i++) {
            var checked = fieldsets[i].querySelector(
                'input[type="radio"]:checked'
            );
            selectedOptions.push(checked ? checked.value : null);
        }

        var match = variants.find(function (v) {
            var j;
            if (!v.options || v.options.length !== selectedOptions.length) {
                return false;
            }
            for (j = 0; j < v.options.length; j++) {
                if (v.options[j] !== selectedOptions[j]) {
                    return false;
                }
            }
            return true;
        });
        return match || null;
    }

    function updateTwaCsModelInfo() {
        var el = document.querySelector(
            '.twa__cs-modelinfo[data-model-text-template]'
        );
        if (!el) {
            return;
        }

        var template = el.getAttribute('data-model-text-template');
        var person = el.getAttribute('data-model-person') || '';
        if (!template) {
            return;
        }

        var vr = document.querySelector('variant-radios');
        if (!vr) {
            return;
        }

        var current = findCurrentVariantFromRadios(vr);
        if (!current) {
            return;
        }

        var sizePart = sizeLabelFromVariantTitle(current.title);
        var text = template
            .split('[modelinfo]')
            .join(person)
            .split('[currentvariant]')
            .join(sizePart);
        el.textContent = text;
    }

    document.addEventListener('change', function (e) {
        if (
            !e.target.matches ||
            !e.target.matches('variant-radios input[type="radio"]')
        ) {
            return;
        }
        updateTwaCsModelInfo();
    });

    window.__twaUpdateCsModelInfo = updateTwaCsModelInfo;
})();
